import { Link } from "react-router-dom";
import style from "./homefooter.module.css";
const HomeFooter = () => {
  return (
    <div
      id="home-footer"
      className="d-block text-center text-md-start d-md-flex  justify-content-between  align-items-center  bg-white  p-4   innercontainer"
    >
      <div className="d-flex align-items-center justify-content-center gap-2 ">
        <img src="/images/logo.svg" alt="logo" />
        <div className="d-none d-md-block">
          @ 2025 Fundlife.me All rights reserved.
        </div>
      </div>

      <div className={`d-flex gap-3 justify-content-center justify-content-md-end  ${style.footermain}` }>
        <Link className={style.footerlink} to="/termofservice">Terms</Link>
        <Link className={style.footerlink} to="/privacy" >Privacy</Link>
        <Link className={style.footerlink } to="/acceptableuseofservice">Acceptable Use Policy </Link>
      </div>
      <span className="d-block d-md-none">
        {" "}
        @ 2025 Fundlife.me All rights reserved.
      </span>
    </div>
  );
};

export default HomeFooter;
